import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const exportToXLSX = ({ data = [], columns = [], columnNames = [], fileName = "document" }) => {
  const res = [];
  for (const obj of data) {
    Object.keys(obj).forEach((key) => {
      if (!columns.includes(key)) delete obj[key];
    });
    res.push(obj);
  }
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const workSheet = XLSX.utils.json_to_sheet(data, { header: columns });
  if (columnNames.length) XLSX.utils.sheet_add_aoa(workSheet, [columnNames], { origin: "A1" });

  const workBook = {
    Sheets: { data: workSheet, cols: columns },
    SheetNames: ["data"],
  };
  const excelBuffer = XLSX.write(workBook, {
    bookType: "xlsx",
    type: "array",
  });
  const fileData = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(fileData, fileName + fileExtension);
};

export { exportToXLSX };
